import React, { Component } from 'react'
import api from '../api'
import { withRouter } from 'react-router-dom'
import Hamburger from './Hamburger'
import './TopBar.css'
import LanguageButton from './LanguageButton'
import { currentLanguage } from './languageContext'

const titles = [
  'Om',
  'Dialogduk',
  'Spill',
  'Nyttige linker',
  'Kontakt',
  'Admin',
]
const titlesMap = {
  Om: '/om',
  Dialogduk: '/dialogduk',
  Spill: '/spill',
  'Nyttige linker': '/linker',
  Admin: '/login',
  Kontakt: '/kontakt',
  'Min side': '/oversikt',
}

class TopBar extends Component {
  state = {
    navOpen: false,
  }

  setActivePage = title => {
    const { history } = this.props
    const token = localStorage.token

    if (title === 'Admin' && token) {
      // TODO log out
      api('logout', { token })
      delete localStorage.token
      this.props.history.push({
        pathname: '/',
        search: history.location.search,
      })
    } else {
      history.push({
        pathname: titlesMap[title],
        search: history.location.search,
      })
    }
  }

  toggleNav = () => {
    const navOpen = !this.state.navOpen

    this.setState({ preAnimate: true }, () => {
      setTimeout(() => {
        this.setState({ animate: true }, () => {
          setTimeout(() => {
            this.setState({ navOpen, animate: false, preAnimate: false })
          }, 100)
        })
      }, 10)
    })
  }

  render() {
    let { activePage } = this.props
    const token = localStorage.token
    const className = ['TopBar-container']

    if (this.state.navOpen) className.push('TopBar-container--open')
    if (this.state.preAnimate) className.push('TopBar-container--preAnimate')
    if (this.state.animate) className.push('TopBar-container--animate')

    if (currentLanguage === 'EN')
      return (
        <div>
          <div
            className={className.join(' ')}
            style={{ pointerEvents: 'none' }}
            key="2"
          >
            <img
              className="TopBar-dd-logo"
              src={require('./static/dd-logo.png')}
              alt=""
            />
          </div>
          <LanguageButton />
        </div>
      )

    return [
      <Hamburger
        open={this.state.navOpen ? true : false}
        key="1"
        onClick={this.toggleNav}
      />,
      <div className={className.join(' ')} key="2">
        <img
          className="TopBar-dd-logo"
          onClick={() => {
            this.props.history.push({
              pathname: '/',
            })
          }}
          src={require('./static/dd-logo.png')}
          alt=""
        />

        <div
          onClick={() => {
            this.props.history.push({
              pathname: '/',
              search: this.props.history.location.search,
            })
          }}
          className="TopBar-title TopBar-home-tab"
        >
          Home
        </div>

        {titles.map(title => (
          <div key={title}>
            {title === 'Admin' && token ? (
              <div className="TopBar-logout-container">
                <div
                  className={
                    activePage === '' || activePage === 'Min side'
                      ? 'TopBar-title TopBar-title--active'
                      : 'TopBar-title'
                  }
                  onClick={() => this.setActivePage('Min side')}
                >
                  {'Min side'}
                </div>
                <div
                  onClick={() => this.setActivePage(title)}
                  key={title}
                  className="TopBar-logout"
                >
                  {'Logg ut'}
                </div>
              </div>
            ) : title === 'Kontakt' && token ? null : (
              <div
                onClick={() => this.setActivePage(title)}
                key={title}
                className={
                  title === 'Admin'
                    ? activePage === title
                      ? 'TopBar-login TopBar-login--active'
                      : 'TopBar-login'
                    : activePage === title
                      ? 'TopBar-title TopBar-title--active'
                      : 'TopBar-title'
                }
              >
                {title}
              </div>
            )}
          </div>
        ))}
        <div className="TopBar-empty-space" />
        <LanguageButton />
      </div>,
    ]
  }
}

export default withRouter(TopBar)



// WEBPACK FOOTER //
// ./src/components/TopBar.js